<template>
    <div class="kmi-search">
        <span role="button"
              class="d-flex nav-link p-0 pl-lg-1 pl-xl-3 mr-lg-n2"
              @click="isOpen = true"
              v-html="iconButton"
        ></span>

        <transition name="fade">
            <div v-if="isOpen" class="search-box">
                <div class="gray-background show" @click="isOpen = false"></div>
                <div v-if="isOpen" class="search-input position-fixed mw-100 px-2">
                    <form class="input-group mb-3 d-block d-md-flex"
                          @submit="checkForm"
                    >
                        <input name="parameter"
                               type="text"
                               required
                               v-model="parameter"
                               class="form-control border-0 rounded-pill px-3 py-2 py-md-1"
                               :placeholder="searchTerm"
                               :aria-label="searchTerm"
                               aria-describedby="basic-addon2"
                        />

                        <div class="input-group-append ml-0 ml-md-2 mt-2 mt-md-0">
                            <button class="border-0 input-group-text rounded-pill py-2 px-3 py-md-1 mx-auto"
                                  type="submit"
                            >
                                <span class="icon mr-2 mr-md-1" v-html="iconSimple"></span>
                                {{ searchButton }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        props: {
            iconButton: {
                type: String,
                default: ''
            },
            iconSimple: {
                type: String,
                default: ''
            },
            endpoint: {
                type: String,
                required: true
            },
            searchTerm: {
                type: String,
                default: 'Keresés'
            },
            searchButton: {
                type: String,
                default: 'Keresés'
            }

        },
        data() {
            return {
                isOpen: false,
                parameter: ''
            }
        },
        methods: {
            checkForm(e) {
                if (this.parameter) {
                    //For demonstration
                    e.preventDefault();

                    window.location.replace(this.endpoint + '?search=' + this.parameter)
                }

                e.preventDefault();
            }
        }
    }
</script>
